export default __webpack_public_path__ + "static/media/still-still-still.0902c6e6.webp";